/**
 * Servicio para manejar los endpoints de toursRefactored
 * Reemplaza el fetch data actual del componente TourProcessingEnhanced
 */
import { API_ROOT } from '../api-config';

class ToursRefactoredService {
  constructor() {
    // Usar la configuración de API_ROOT para construir la URL base
    this.baseURL = `${API_ROOT}/toursRefactored`;
    console.log(`[ToursRefactoredService] URL base configurada: ${this.baseURL}`);
  }

  /**
   * Obtener un tour específico (pendiente o procesado)
   * @param {number} id - ID del tour
   * @returns {Promise<Object>} Datos del tour
   */
  async getTour(id) {
    try {
      console.log(`[ToursRefactoredService] Intentando obtener tour con ID: ${id}`);
      console.log(`[ToursRefactoredService] URL: ${this.baseURL}/${id}`);
      
      const token = localStorage.getItem('token');
      console.log(`[ToursRefactoredService] Token disponible: ${!!token}`);
      
      const response = await fetch(`${this.baseURL}/${id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });

      console.log(`[ToursRefactoredService] Response status: ${response.status}`);
      console.log(`[ToursRefactoredService] Response statusText: ${response.statusText}`);

      if (!response.ok) {
        const errorText = await response.text();
        console.error(`[ToursRefactoredService] Error response body:`, errorText);
        throw new Error(`Error al obtener tour: ${response.status} ${response.statusText} - ${errorText}`);
      }

      const result = await response.json();
      console.log(`[ToursRefactoredService] Response data:`, result);
      
      if (!result.success) {
        throw new Error(result.error || 'Error al obtener tour');
      }

      return result.data;
    } catch (error) {
      console.error('[ToursRefactoredService] Error en getTour:', error);
      throw error;
    }
  }

  /**
   * Obtener tour pendiente específico
   * @param {number} id - ID del tour
   * @returns {Promise<Object>} Datos del tour pendiente
   */
  async getPendingTour(id) {
    try {
      console.log(`[ToursRefactoredService] Intentando obtener tour pendiente con ID: ${id}`);
      console.log(`[ToursRefactoredService] URL: ${this.baseURL}/pending/${id}`);
      
      const token = localStorage.getItem('token');
      console.log(`[ToursRefactoredService] Token disponible: ${!!token}`);
      
      const response = await fetch(`${this.baseURL}/pending/${id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });

      console.log(`[ToursRefactoredService] Response status: ${response.status}`);
      console.log(`[ToursRefactoredService] Response statusText: ${response.statusText}`);

      if (!response.ok) {
        const errorText = await response.text();
        console.error(`[ToursRefactoredService] Error response body:`, errorText);
        throw new Error(`Error al obtener tour pendiente: ${response.status} ${response.statusText} - ${errorText}`);
      }

      const result = await response.json();
      console.log(`[ToursRefactoredService] Response data:`, result);
      
      if (!result.success) {
        throw new Error(result.error || 'Error al obtener tour pendiente');
      }

      return result.data;
    } catch (error) {
      console.error('[ToursRefactoredService] Error en getPendingTour:', error);
      throw error;
    }
  }

  /**
   * Obtener tour procesado específico
   * @param {number} id - ID del tour
   * @returns {Promise<Object>} Datos del tour procesado
   */
  async getProcessedTour(id) {
    try {
      console.log(`[ToursRefactoredService] Intentando obtener tour procesado con ID: ${id}`);
      console.log(`[ToursRefactoredService] URL: ${this.baseURL}/processed/${id}`);
      
      const token = localStorage.getItem('token');
      console.log(`[ToursRefactoredService] Token disponible: ${!!token}`);
      
      const response = await fetch(`${this.baseURL}/processed/${id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });

      console.log(`[ToursRefactoredService] Response status: ${response.status}`);
      console.log(`[ToursRefactoredService] Response statusText: ${response.statusText}`);

      if (!response.ok) {
        const errorText = await response.text();
        console.error(`[ToursRefactoredService] Error response body:`, errorText);
        throw new Error(`Error al obtener tour procesado: ${response.status} ${response.statusText} - ${errorText}`);
      }

      const result = await response.json();
      console.log(`[ToursRefactoredService] Response data:`, result);
      
      if (!result.success) {
        throw new Error(result.error || 'Error al obtener tour procesado');
      }

      return result.data;
    } catch (error) {
      console.error('[ToursRefactoredService] Error en getProcessedTour:', error);
      throw error;
    }
  }

  /**
   * Procesar un tour pendiente
   * @param {number} id - ID del tour
   * @param {Object} tourData - Datos para procesar el tour
   * @returns {Promise<Object>} Resultado del procesamiento
   */
  async processTour(id, tourData) {
    try {
      const response = await fetch(`${this.baseURL}/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify(tourData)
      });

      if (!response.ok) {
        throw new Error(`Error al procesar tour: ${response.status} ${response.statusText}`);
      }

      const result = await response.json();
      
      if (!result.success) {
        const error = new Error(result.error || 'Error al procesar tour');
        error.details = result.details || [];
        throw error;
      }

      return result.data;
    } catch (error) {
      console.error('Error en processTour:', error);
      throw error;
    }
  }

  /**
   * Actualizar un tour procesado
   * @param {number} id - ID del tour
   * @param {Object} tourData - Datos para actualizar el tour
   * @returns {Promise<Object>} Resultado de la actualización
   */
  async updateProcessedTour(id, tourData) {
    try {
      const response = await fetch(`${this.baseURL}/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify(tourData)
      });

      if (!response.ok) {
        throw new Error(`Error al actualizar tour: ${response.status} ${response.statusText}`);
      }

      const result = await response.json();
      
      if (!result.success) {
        const error = new Error(result.error || 'Error al actualizar tour');
        error.details = result.details || [];
        throw error;
      }

      return result.data;
    } catch (error) {
      console.error('Error en updateProcessedTour:', error);
      throw error;
    }
  }

  /**
   * Validar datos de un tour
   * @param {number} id - ID del tour
   * @param {Object} tourData - Datos a validar
   * @returns {Promise<Object>} Resultado de la validación
   */
  async validateTour(id, tourData) {
    try {
      const response = await fetch(`${this.baseURL}/${id}/validate`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify(tourData)
      });

      if (!response.ok) {
        throw new Error(`Error al validar tour: ${response.status} ${response.statusText}`);
      }

      const result = await response.json();
      
      if (!result.success) {
        throw new Error(result.error || 'Error al validar tour');
      }

      return result.data;
    } catch (error) {
      console.error('Error en validateTour:', error);
      throw error;
    }
  }


  /**
   * Cancelar un tour
   * @param {number} id - ID del tour
   * @param {Object} cancelData - Datos de cancelación
   * @returns {Promise<Object>} Resultado de la cancelación
   */
  async cancelTour(id, cancelData = {}) {
    try {
      const response = await fetch(`${this.baseURL}/${id}/cancel`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify(cancelData)
      });

      if (!response.ok) {
        throw new Error(`Error al cancelar tour: ${response.status} ${response.statusText}`);
      }

      const result = await response.json();
      
      if (!result.success) {
        throw new Error(result.error || 'Error al cancelar tour');
      }

      return result.data;
    } catch (error) {
      console.error('Error en cancelTour:', error);
      throw error;
    }
  }

  /**
   * Obtener estadísticas de tours
   * @returns {Promise<Object>} Estadísticas de tours
   */
  async getStats() {
    try {
      const response = await fetch(`${this.baseURL}/stats/overview`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });

      if (!response.ok) {
        throw new Error(`Error al obtener estadísticas: ${response.status} ${response.statusText}`);
      }

      const result = await response.json();
      
      if (!result.success) {
        throw new Error(result.error || 'Error al obtener estadísticas');
      }

      return result.data;
    } catch (error) {
      console.error('Error en getStats:', error);
      throw error;
    }
  }

  /**
   * Buscar tours con filtros
   * @param {Object} filters - Filtros de búsqueda
   * @returns {Promise<Object>} Resultados de la búsqueda
   */
  async searchTours(filters = {}) {
    try {
      const queryString = new URLSearchParams(filters).toString();
      const response = await fetch(`${this.baseURL}/search?${queryString}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });

      if (!response.ok) {
        throw new Error(`Error en búsqueda: ${response.status} ${response.statusText}`);
      }

      const result = await response.json();
      
      if (!result.success) {
        throw new Error(result.error || 'Error en búsqueda');
      }

      return result.data;
    } catch (error) {
      console.error('Error en searchTours:', error);
      throw error;
    }
  }

  /**
   * Obtener tours con filtros específicos
   * @param {Object} params - Parámetros de consulta
   * @returns {Promise<Object>} Lista de tours
   */
  async getTours(params = {}) {
    try {
      const queryString = new URLSearchParams(params).toString();
      const response = await fetch(`${this.baseURL}?${queryString}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });

      if (!response.ok) {
        throw new Error(`Error al obtener tours: ${response.status} ${response.statusText}`);
      }

      const result = await response.json();
      
      if (!result.success) {
        throw new Error(result.error || 'Error al obtener tours');
      }

      return result.data;
    } catch (error) {
      console.error('Error en getTours:', error);
      throw error;
    }
  }
}

export default ToursRefactoredService;



// WEBPACK FOOTER //
// ./src/services/ToursRefactoredService.js